const pulse = () => {
  const calendarContainer = document.querySelector('.calendarContainer').classList;
  calendarContainer.add('pulse');
  document.querySelector('.calendarContainer').addEventListener('animationend', () => calendarContainer.remove('pulse'));
};

export default pulse;